export const environment = {
  production: true,
  apiUrl: 'https://api.grioplus.com',
  stripe_public_key:
    'pk_live_51Oa6YHEs3P3qrjUPQdme0WHd2ceW9owT2U566EDo3tvPU7jsG7YZEphKLUXG6N1wdWE6RxtkZDobCjSrvLvFngS500djwxeH6I',
  s3BucketUrl: 'https://grio-plus.s3.ap-southeast-2.amazonaws.com',
};
